import { createRealtimeHook, MockNatsAdapter } from "@web-monorepo/realtime";
import { installRealtimeTestBridge } from "@web-monorepo/realtime/playwright-bridge";
import env from "shared/util/env";
import { metrics } from "src/utils/metrics";

export const mockAdapter = env.isTesting ? new MockNatsAdapter() : null;

// Test-only NATS seam, so Playwright specs can drive cross-device flows. `mockAdapter` is null
// outside testing, and the installer ignores a null adapter. See ai/rules/nats-realtime.md.
installRealtimeTestBridge(mockAdapter);

// onRecovered/onRecoveryExhausted callbacks intentionally omitted: toolkit has no banner UI
// for realtime issues (when embedded as a remote in teach, teach's banner covers it;
// standalone surfaces would notice broken cross-display sync directly).
//
// isExhaustedStateMachineEnabled is always-on (not gated by the feature switch) because
// standalone toolkit (kiosk /apps/display) has no session/feature-switch infra to read a
// per-user switch from. This is intentional per the exhausted-state-machine plan: the slow
// re-dial loop IS the kiosk self-recovery fix, and it's low-risk here specifically — E1's
// poll fallback self-skips (toolkit registers no refetch listeners via addReconnectListener),
// so the only always-on cost is the slow re-dial itself. isExhaustedPollEnabled mirrors that:
// always-on but a no-op fan-out here, for the same no-switch-infra reason.
export const {
  useRealtime,
  publish: realtimePublish,
  init: realtimeInit,
  close: realtimeClose,
  subscribeReconnect,
  getReconnectSnapshot,
} = createRealtimeHook({
  serverUrl: `wss://${window.location.host}/nats`,
  name: "web-toolkit",
  mockAdapter,
  metrics,
  isExhaustedStateMachineEnabled: () => true,
  isExhaustedPollEnabled: () => true,
});
